import WhaleIsland from '../3-fishfood/WhaleIsland';
import EmailGame from './EmailGame';
import SquidIntro from './SquidIntro';
import TurtleQuestion from './TurtleQuestion';
import UserDodge from './UserDodge';
import UserDodgePhisher from './UserDodgePhisher';

export default [WhaleIsland, SquidIntro, EmailGame, UserDodge, UserDodgePhisher, TurtleQuestion];
